export const AUTOPLAY_INIT_VALUE = {
  /** {@link AutoPlayType} */
  type: null,
  /** {@link AutoPlayStatus} */
  status: null,
  /** Is looping video? Includes types LOOP and LOOP_NO_CONTROLS  */
  isLooping: false,
  /** Is autoplaying video? Includes types AUTO, LOOP and LOOP_NO_CONTROLS */
  isAutoplay: false,
  /** Should video preroll? */
  isPreroll: false,
  /** Is autoplay due to live preview? */
  isLivePreview: false,
  /** Is playthrough mode? */
  isPlaythrough: false,
  /** Has autoplay state been initialized? */
  isInitialized: false,
  /** Should override autoplay mute behavior? */
  overrideAutoplayMuteBehavior: false
};
